import { HelperCore } from '@/common/dependencies';
import { makeAutoObservable, runInAction } from 'mobx';

class Store {
  content = "";
  switchCount = 0
  inputRef = null;
  constructor () {
    makeAutoObservable(this);

    if(!HelperCore.IS_PROD){
      window._chatInputStore = this;
    }
  }

  setInputRef(ref) {
    this.inputRef = ref;
  }

  setContent (content) {
    this.content = content;
  }
  appendContent (content) {
    this.content += content;
  }
  setSwitchCount() {
    this.switchCount = ++this.switchCount
  }
}

const chatInputStore = new Store();
export default chatInputStore;